import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloDropdownIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M10 18L16 12H4L10 18Z' fill='currentColor' />
    <path fillRule='evenodd' clipRule='evenodd' d='M10 2L16 8H4L10 2Z' fill='currentColor' />
  </EloBaseIcon>
)
